<template>
  <v-container grid-list-sm fluid>
    <div :class="cssClass">
      <h1>{{ translate['page_not_found'][lang] }}</h1>
    </div>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'PageNotFound',
  // data () {
  //   return {
  //     // cssClass: this.$options.name.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase()
  //   }
  // },
  computed: {
    ...mapGetters([
      'translate',
      'lang'
    ]),
    cssClass () {
      return this.$options.name.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase()
    }
  }
}
</script>
<style lang="scss">
.page-not-found {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: calc(100vh - 16px);
}
</style>



// WEBPACK FOOTER //
// src/components/pages/PageNotFound.vue